import React, { useState, useEffect } from "react";
import "../styles.css";

function ModalCrearUsuario({ visible, onClose, onGuardar }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rol, setRol] = useState("user");
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [exito, setExito] = useState(null);

  useEffect(() => {
    if (visible) {
      setUsername("");
      setPassword("");
      setRol("user");
      setError(null);
      setExito(null);
      setCargando(false);
    }
  }, [visible]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setExito(null);
    setCargando(true);

    try {
      if (onGuardar) {
        await onGuardar(username, password, rol);
        setExito(`Usuario '${username}' creado correctamente`);
      }
    } catch (err) {
      setError(err.message || "Error creando usuario");
    } finally {
      setCargando(false);
    }
  };

  if (!visible) return null; 

  return (
    <div className="modal-overlay">
      <div className="modal modal-ancho">
        <h2>Crear Nuevo Usuario</h2>

        <form onSubmit={handleSubmit} className="form-licitacion">
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Rol</label>
            <select value={rol} onChange={(e) => setRol(e.target.value)}>
              <option value="user">Usuario</option>
              <option value="admin">Administrador</option>
            </select>
          </div>

          {error && <p className="mensaje-error">{error}</p>}
          {exito && <p className="mensaje-exito">{exito}</p>}

          <div className="modal-actions">
            <button
              type="submit"
              className="botonAccion botonAzul"
              disabled={cargando}
            >
              {cargando ? "Guardando..." : "Guardar"}
            </button>
            <button
              type="button"
              className="botonAccion botonAzul"
              onClick={onClose}
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModalCrearUsuario;
